import React, {FC} from 'react';

/** Русский текст соглашения о покупке подписки (новый перевод, предыдущей русской редакции нет; структура 1:1 соответствует content/en; 2026-09-17 AI-перевод, юридические формулировки ожидают проверки бизнесом) */
const RuContent: FC = () => {
  return (
    <>
      <p className="v3-doc-meta">Дата вступления в силу: August 28, 2026</p>
      <p className="v3-doc-meta">Дата последнего обновления: August 28, 2026</p>
      <p>Добро пожаловать в услуги подписки, предоставляемые компанией Xiangji (далее — «Xiangji»).</p>
      <p>
        Компания Xiangji предоставляет вам платные дополнительные услуги, включая, помимо прочего, перевод изображений,
        редактирование изображений, генерацию товарных изображений, генерацию комплектов детальных изображений товаров,
        генерацию главных и дополнительных изображений товаров и другие услуги, связанные с созданием ИИ-визуального
        контента (далее — «услуги подписки»).
      </p>
      <p>
        Для использования услуг подписки Xiangji вам необходимо приобрести соответствующие тарифные планы подписки в
        соответствии с тарифами, опубликованными Xiangji. Перед покупкой и использованием услуг подписки, пожалуйста,
        внимательно прочитайте и полностью поймите всё содержание настоящего Соглашения о подписке Xiangji (далее —
        «настоящее Соглашение»).
      </p>
      <p>
        <strong>
          Xiangji особо напоминает: обратите внимание на положения настоящего Соглашения, касающиеся освобождения от
          ответственности или её ограничения, ограничений прав пользователя, изменений услуг, возвратов, управления
          учётной записью, автопродления, юридической ответственности и разрешения споров. Указанные положения могут
          затрагивать ваши существенные права и интересы. Обязательно внимательно прочитайте их до покупки услуг
          подписки.
        </strong>
      </p>
      <p>
        Если вы не согласны с каким-либо или со всеми положениями настоящего Соглашения, пожалуйста, не приобретайте и
        не используйте услуги подписки Xiangji. Нажатие кнопок «Купить сейчас», «Подтвердить покупку», «Согласиться и
        оплатить» или других аналогичных кнопок, равно как завершение оплаты или начало использования услуг подписки,
        означает, что вы полностью прочитали и поняли настоящее Соглашение и согласны быть связанными всеми его
        условиями.
      </p>
      <p>
        Если вам не исполнилось 18 лет, пожалуйста, прочитайте и подтвердите настоящее Соглашение в сопровождении
        законного представителя, а также приобретайте и используйте услуги подписки только после получения согласия
        вашего законного представителя.
      </p>
      <section>
        <h2>1. Определения и пояснения к Соглашению</h2>
        <ol>
          <li>
            <strong>Xiangji</strong>
            <p>
              «Xiangji» означает <strong>[Suzhou Xiangji Technology Service Co., Ltd.]</strong>, а также оперируемые ею
              веб-сайт Xiangji, веб-приложение, клиентское приложение, браузерное расширение и другие связанные продукты
              и услуги.
            </p>
            <p>Официальный веб-сайт Xiangji:</p>
            <p>
              <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
                <strong>https://www.xiangjifanyi.com/</strong>
              </a>
            </p>
            <p>
              Конкретные входы в сервисы и платформы, фактически предоставляющие услуги, определяются информацией,
              опубликованной на официальных страницах Xiangji.
            </p>
          </li>
          <li>
            <strong>Пользователь</strong>
            <p>
              Пользователь — это физическое лицо, юридическое лицо или организация без образования юридического лица,
              которые регистрируются, входят в учётную запись Xiangji и приобретают или используют услуги подписки
              Xiangji.
            </p>
            <p>
              В настоящем Соглашении «вы» и «пользователь» означают покупателя и фактического пользователя услуг
              подписки.
            </p>
          </li>
          <li>
            <strong>Услуги подписки</strong>
            <p>
              Услуги подписки — это услуги создания ИИ-визуального контента и связанные дополнительные услуги, которые
              Xiangji предоставляет пользователям в течение согласованного периода подписки на основании конкретных
              тарифных планов подписки, приобретённых пользователем.
            </p>
            <p>Конкретное содержание услуг может включать, помимо прочего:</p>
            <ul>
              <li>перевод изображений товаров;</li>
              <li>редактирование изображений товаров;</li>
              <li>генерацию изображений товаров;</li>
              <li>генерацию изображений товарных сцен;</li>
              <li>генерацию изображений товаров с моделями;</li>
              <li>генерацию главных и дополнительных изображений товаров;</li>
              <li>генерацию комплектов детальных изображений товаров;</li>
              <li>генерацию детальных страниц товаров, A+ страниц и другого контента;</li>
              <li>обработку видео и другого визуального контента;</li>
              <li>другие услуги ИИ-визуального контента, периодически запускаемые Xiangji.</li>
            </ul>
            <p>
              <strong>
                Конкретное содержание услуг, преимущества плана, количество использований, квоты, сроки действия,
                спецификации обработки и другие правила услуг определяются содержанием, фактически отображаемым на
                соответствующих страницах на момент покупки.
              </strong>
            </p>
          </li>
          <li>
            <strong>Тарифные планы подписки</strong>
            <p>
              Тарифные планы подписки — это различные сервисные комбинации, предоставляемые Xiangji с учётом различных
              потребностей пользователей, включая, помимо прочего, месячную, квартальную и годовую подписку и другие
              периодические подписочные продукты.
            </p>
            <p>
              Различные тарифные планы могут отличаться ценой, содержанием услуг, квотами использования и
              преимуществами. За подробностями обращайтесь к информации, отображаемой на странице покупки.
            </p>
          </li>
          <li>
            <strong>Период подписки</strong>
            <p>
              Период подписки — это срок действия, в течение которого после приобретения тарифного плана подписки
              пользователь может пользоваться соответствующими преимуществами подписки.
            </p>
            <p>
              Период подписки может быть месячным, квартальным, годовым или иным периодом, предоставляемым Xiangji. За
              подробностями обращайтесь к информации, отображаемой на странице покупки.
            </p>
          </li>
          <li>
            <strong>Преимущества подписки</strong>
            <p>
              Преимущества подписки — это сервисные квоты, функциональные разрешения и другие преимущества, получаемые
              пользователем в течение периода подписки в соответствии с приобретённым планом.
            </p>
            <p>
              <strong>
                Преимущества подписки, соответствующие различным планам, могут различаться. За подробностями обращайтесь
                к странице покупки и правилам, официально опубликованным Xiangji.
              </strong>
            </p>
          </li>
          <li>
            <strong>Настоящее Соглашение</strong>
            <p>
              Настоящее Соглашение является важной составной частью Соглашения об обслуживании пользователей Xiangji,
              Политики конфиденциальности, соглашений об ИИ-услугах и других связанных правил оказания услуг.
            </p>
            <p>
              Настоящее Соглашение вместе с вышеуказанными соглашениями составляет полную договорённость между Xiangji и
              пользователем в отношении услуг подписки.
            </p>
            <p>
              В случае несоответствия между настоящим Соглашением и другими соглашениями в отношении услуг подписки
              преимущественную силу имеют положения настоящего Соглашения об услугах подписки; остальные вопросы
              по-прежнему регулируются соответствующими соглашениями.
            </p>
          </li>
          <li>
            <strong>Правила услуг</strong>
            <p>
              Содержание настоящего Соглашения также включает соответствующие объявления, описания страниц, правила
              продуктов, правила тарификации, справочные документы и другие сервисные спецификации, публикуемые Xiangji
              с учётом потребностей развития бизнеса.
            </p>
            <p>
              После официальной публикации вышеуказанное содержание является неотъемлемой частью настоящего Соглашения и
              имеет такую же юридическую силу, как и настоящее Соглашение.
            </p>
          </li>
        </ol>
      </section>
      <section>
        <h2>2. Покупка и использование услуг подписки</h2>
        <ol>
          <li>Учётная запись и покупка</li>
        </ol>
        <p>1.1 Для покупки услуг подписки вам необходимо зарегистрировать учётную запись Xiangji или войти в неё.</p>
        <p>
          Учётная запись, которую вы используете на платформе Xiangji, является основным основанием для Xiangji при
          идентификации вашей личности и предоставлении преимуществ подписки.
        </p>
        <p>
          1.2 Вы должны надлежащим образом хранить свою учётную запись, пароль и связанную с учётной записью информацию,
          а также несёте соответствующую ответственность за операции, совершённые через вашу учётную запись.
        </p>
        <p>
          <strong>
            Без письменного разрешения Xiangji вы не вправе предоставлять права использования учётной записи другим
            сторонам путём сдачи в аренду, предоставления в пользование, передачи, совместного использования, продажи
            или иными способами.
          </strong>
        </p>
        <p>
          Если Xiangji обнаружит аномальные входы, массовое совместное использование, злоумышленное использование или
          иные ситуации, влияющие на нормальную работу платформы, Xiangji вправе принять такие меры, как ограничение
          входа, ограничение функций, приостановка услуг или другие разумные меры.
        </p>
        <p>
          1.3 Если вы входите в Xiangji через стороннюю учётную запись, вы должны обеспечить, чтобы сторонняя учётная
          запись была подлинной, законной и действительной.
        </p>
        <p>
          Если вы не можете войти в Xiangji или нормально использовать услуги подписки по причинам, связанным с самой
          сторонней учётной записью, вам следует обратиться к соответствующей третьей стороне для разрешения.
        </p>
        <p>
          1.4 Вы должны обеспечить, чтобы информация, указанная при покупке услуг подписки, была достоверной, точной и
          полной.
        </p>
        <p>
          Вы несёте любые убытки, вызванные неправильным заполнением, ошибочным выбором или ненадлежащими действиями с
          вашей стороны.
        </p>
      </section>
      <section>
        <h2>3. Тарифные планы подписки и тарифы</h2>
        <ol>
          <li>
            Цены на подписку
            <p>
              Цены, циклы тарификации и конкретные преимущества различных тарифных планов подписки определяются
              информацией, фактически отображаемой на официальной странице покупки Xiangji.
            </p>
            <p>
              Xiangji вправе корректировать цены тарифных планов подписки с учётом условий эксплуатации продукта,
              рыночных изменений и изменения затрат. Однако в отношении уже приобретённых услуг подписки, всё ещё
              находящихся в пределах срока действия, если иное не предусмотрено законами и нормативными актами или не
              согласовано сторонами, ретроспективная корректировка вследствие последующих изменений цен производиться не
              будет.
            </p>
          </li>
          <li>
            Преимущества подписки
            <p>
              После приобретения тарифного плана подписки пользователь может использовать соответствующие услуги в
              течение срока действия подписки в соответствии с правилами соответствующего плана.
            </p>
            <p>Различные функции могут тарифицироваться по разным методам, включая, помимо прочего:</p>
            <ul>
              <li>тарификацию за каждое использование;</li>
              <li>тарификацию по количеству изображений;</li>
              <li>тарификацию по задачам генерации;</li>
              <li>тарификацию по времени обработки;</li>
              <li>тарификацию по сервисным квотам;</li>
              <li>тарификацию по количеству использований или квотам, включённым в план.</li>
            </ul>
            <p>
              <strong>
                Конкретные стандарты списания и правила потребления определяются информацией, отображаемой на странице
                фактически используемой функции.
              </strong>
            </p>
          </li>
          <li>
            Срок действия преимуществ
            <p>
              Если иное не указано на странице покупки, преимущества подписки действительны только в пределах
              соответствующего периода подписки.
            </p>
            <p>
              После истечения периода подписки вопрос о переносе неиспользованных квот подписки, количества
              использований или иных временных преимуществ определяется конкретными правилами плана.
            </p>
            <p>
              <strong>
                Если на странице покупки явно указано, что соответствующие квоты не подлежат переносу, неиспользованные
                квоты автоматически аннулируются по окончании периода подписки.
              </strong>
            </p>
          </li>
          <li>
            Повышение тарифного плана
            <p>
              Если Xiangji предоставляет услуги повышения плана, пользователь может выполнить повышение в соответствии с
              правилами, отображаемыми на странице покупки.
            </p>
            <p>
              Доплата разницы в цене, оставшийся период и порядок расчёта преимуществ, связанные с повышением,
              определяются правилами, фактически отображаемыми на страницах Xiangji.
            </p>
          </li>
          <li>
            Понижение тарифного плана
            <p>
              Если Xiangji предоставляет услуги понижения плана, правила понижения определяются информацией, фактически
              отображаемой на странице покупки.
            </p>
            <p>
              Некоторые планы могут не поддерживать прямое понижение. Пользователь может снова выбрать другой план после
              окончания текущего периода подписки.
            </p>
          </li>
        </ol>
      </section>
      <section>
        <h2>4. Услуги автопродления</h2>
        <p>
          Если Xiangji предоставляет функцию автопродления, пользователям следует при покупке обратить особое внимание
          на инструкции, связанные с автопродлением.
        </p>
        <p>
          1. Если пользователь активно выбирает включение услуги автопродления, то до истечения текущего периода
          подписки Xiangji может автоматически списывать плату за подписку за следующий период с помощью способа оплаты,
          авторизованного пользователем, в соответствии с выбранным пользователем периодом продления и ценой продления,
          действующей на тот момент.
        </p>
        <p>
          2. Конкретная цена, время списания, период продления и способ отмены автопродления определяются информацией,
          отображаемой на страницах покупки и управления пользователя.
        </p>
        <p>
          3.
          <strong>
            Пользователь может отменить автопродление до следующего автоматического списания способом, предусмотренным
            на страницах Xiangji. После отмены автопродления текущий период подписки, уже приобретённый пользователем,
            не затрагивается и может использоваться до окончания текущего периода подписки.
          </strong>
        </p>
        <p>
          4. Если автопродление не удалось из-за недостаточного баланса платёжного счёта, ограничений платёжной
          организации, истечения срока действия банковской карты или по иным причинам, не зависящим от Xiangji, Xiangji
          не гарантирует, что услуги следующего периода подписки могут продолжать предоставляться.
        </p>
      </section>
      <section>
        <h2>5. Правила использования услуг подписки</h2>
        <ol>
          <li>
            Приобретённые вами услуги подписки ограничены соответствующими услугами, предоставляемыми на платформе
            Xiangji.
            <p>
              Без письменного разрешения Xiangji вы не вправе с помощью технических средств, программ, скриптов или иных
              способов обходить, взламывать или нейтрализовывать механизмы тарификации, квот, разрешений или контроля
              доступа Xiangji.
            </p>
          </li>
          <li>
            Вы не вправе использовать услуги Xiangji для создания, генерации, распространения или обработки контента,
            нарушающего законы и нормативные акты, общественный порядок и нравственность либо нарушающего законные права
            и интересы третьих лиц.
            <p>Включая, помимо прочего:</p>
            <ul>
              <li>незаконную, мошенническую или ложную информацию;</li>
              <li>контент, нарушающий интеллектуальную собственность других лиц;</li>
              <li>
                контент, нарушающий такие законные права и интересы других лиц, как неприкосновенность частной жизни,
                права на изображение и деловую репутацию;
              </li>
              <li>незаконный контент, такой как порнография, насилие, терроризм и экстремизм;</li>
              <li>иной контент, запрещённый законами и нормативными актами или правилами платформы Xiangji.</li>
            </ul>
          </li>
          <li>
            Вы не вправе использовать услуги Xiangji для массовой регистрации, злонамеренных вызовов, мошенничества с
            трафиком, арбитражных схем, атак на платформу, вмешательства в её нормальную работу или иного подобного
            поведения.
          </li>
          <li>
            Если вы обнаружите аномальное использование вашей учётной записи, вам следует незамедлительно обратиться в
            службу поддержки Xiangji.
            <p>
              Вы несёте любые убытки, возникшие вследствие утечки вашей учётной записи, пароля или платёжной информации
              по вашим собственным причинам.
            </p>
          </li>
        </ol>
      </section>
      <section>
        <h2>6. Особые примечания об ИИ-услугах</h2>
        <ol>
          <li>
            Результаты, генерируемые ИИ
            <p>
              Часть услуг Xiangji предоставляется на основе моделей искусственного интеллекта, алгоритмов и сторонней
              ИИ-инфраструктуры.
            </p>
            <p>
              <strong>
                Поскольку генерация ИИ связана с определённой степенью неопределённости, генерируемые ИИ результаты
                могут не полностью соответствовать вашим ожиданиям и могут содержать ошибки в содержании, текстовые
                ошибки, фактические ошибки, визуальные дефекты или иные непредвиденные ситуации.
              </strong>
            </p>
            <p>
              Перед использованием сгенерированного ИИ контента в коммерческой деятельности, выпуске продуктов, рекламе
              или в иных целях вам следует провести необходимую ручную проверку.
            </p>
          </li>
          <li>
            Отсутствие гарантии уникальности результатов
            <p>
              Вы понимаете и соглашаетесь, что одинаковые или схожие входные данные могут приводить к одинаковым или
              различным результатам, и Xiangji не гарантирует уникальность сгенерированных результатов.
            </p>
          </li>
          <li>
            Ответственность за проверку контента, сгенерированного ИИ
            <p>
              Вы несёте соответствующую ответственность за материалы, загруженные на платформу Xiangji, и за итоговый
              контент, сгенерированный, отредактированный или переведённый с использованием Xiangji.
            </p>
            <p>
              В частности, в отношении важной информации, затрагивающей права и интересы потребителей, — такой как
              названия товаров, характеристики, цены, функции, параметры, сертификаты и заявленная эффективность, — вам
              следует проводить ручную проверку.
            </p>
          </li>
          <li>
            Сторонние модели и услуги
            <p>
              Часть ИИ-функций Xiangji может полагаться на сторонние модели, облачные вычисления, услуги перевода,
              услуги хранения или иные технические услуги.
            </p>
            <p>
              Если соответствующие функции временно недоступны из-за сбоев, корректировок, обновлений, ограничений или
              прекращения сторонних услуг, Xiangji в разумных пределах примет замещающие, восстановительные или иные
              меры, но в той мере, в какой это допускается законом, не несёт ответственности за вызванные этим косвенные
              убытки.
            </p>
          </li>
        </ol>
      </section>
      <section>
        <h2>7. Пользовательский контент и интеллектуальная собственность</h2>
        <ol>
          <li>
            Вы должны обеспечить, чтобы изображения, тексты, видео, информация о товарах и иной контент, загруженные на
            платформу Xiangji, были разрешены к использованию на законных основаниях. Если загружаемый, обрабатываемый
            или используемый вами контент нарушает интеллектуальную собственность, права на изображение, права на
            неприкосновенность частной жизни или иные законные права и интересы любого третьего лица, вы несёте
            вытекающую из этого ответственность.
          </li>
          <li>
            В отношении оригинальных материалов, которые вы загружаете или обрабатываете через Xiangji, соответствующие
            права по общему правилу по-прежнему принадлежат вам или соответствующим правообладателям.
          </li>
          <li>
            В отношении контента, генерируемого вами через услуги Xiangji, принадлежность соответствующих прав и объём
            его использования определяются применимыми законами и нормативными актами, а также действующим на
            соответствующий момент соглашением Xiangji об ИИ-услугах или конкретными правилами продукта.
          </li>
          <li>
            Xiangji вследствие вашего нормального использования услуг подписки не приобретает права интеллектуальной
            собственности на загруженный вами контент, законно принадлежащие вам. Однако в целях предоставления вам
            услуг, а также выполнения технической обработки, хранения, передачи, отображения и связанных функций вы
            соглашаетесь, что Xiangji обрабатывает соответствующий контент в объёме, необходимом для предоставления
            услуг.
          </li>
        </ol>
      </section>
      <section>
        <h2>8. Возвраты и отмена подписки</h2>
        <ol>
          <li>
            Перед покупкой услуг подписки пользователь должен в полной мере убедиться в плане, периоде подписки, цене,
            преимуществах и области применения покупки.
          </li>
          <li>
            Если иное не предусмотрено законами и нормативными актами, прямо не обещано на страницах Xiangji или услуги
            не могут быть предоставлены по причинам, связанным с самой Xiangji,
            <strong>
              то в отношении услуг подписки, использование которых уже началось, возврат средств или обмен на другие
              услуги по личным причинам пользователя по общему правилу не поддерживается.
            </strong>
          </li>
          <li>
            В отношении подписочных заказов, использование которых ещё не начато и которые соответствуют правилам
            возврата Xiangji, пользователь может подать заявление на возврат в соответствии с официально опубликованным
            Xiangji процессом возврата. Конкретные условия возврата и порядок обработки определяются действующими на тот
            момент правилами возврата Xiangji.
          </li>
          <li>
            Если пользователь производит оплату через стороннюю платёжную платформу, срок зачисления возврата может
            зависеть от времени обработки соответствующей платёжной организации.
          </li>
        </ol>
      </section>
      <section>
        <h2>9. Изменение, приостановка и прекращение услуг</h2>
        <ol>
          <li>
            Xiangji вправе вносить разумные корректировки в услуги подписки с учётом развития бизнеса, технических
            обновлений, рыночных изменений и требований законов и нормативных актов, включая, помимо прочего:
            <ul>
              <li>добавление или сокращение сервисных функций;</li>
              <li>корректировку содержания планов;</li>
              <li>корректировку сервисных квот;</li>
              <li>корректировку способов тарификации;</li>
              <li>замену ИИ-моделей или технических решений;</li>
              <li>приостановку или прекращение части услуг.</li>
            </ul>
          </li>
          <li>
            В отношении уже приобретённых услуг подписки, всё ещё находящихся в пределах срока действия, если Xiangji по
            собственным причинам окончательно прекращает предоставление соответствующих основных услуг, Xiangji в
            зависимости от конкретных обстоятельств предоставит разумные альтернативные решения, продление, возврат
            средств или иные способы урегулирования.
          </li>
          <li>
            Если услуги временно прерываются из-за технического обслуживания системы, обновлений, сетевых сбоев,
            аномалий сторонних услуг, обстоятельств непреодолимой силы или по иным причинам, Xiangji приложит разумные
            усилия для как можно более быстрого восстановления услуг.
          </li>
        </ol>
      </section>
      <section>
        <h2>10. Особые примечания и отказ от ответственности</h2>
        <p>
          <strong>
            В максимальной допускаемой законом степени, если пользователи не могут нормально использовать услуги
            подписки по следующим причинам, Xiangji не несёт ответственности за вытекающие из этого косвенные убытки или
            ответственность за пределами, установленными законом:
          </strong>
        </p>
        <ol>
          <li>
            Xiangji проводит техническое обслуживание, обновление или корректировку системы в соответствии с
            объявлениями;
          </li>
          <li>сбои телекоммуникационных операторов, поставщиков сетевых услуг или иной инфраструктуры;</li>
          <li>аномалии в сторонних платёжных сервисах, облачных услугах, ИИ-моделях или иных сторонних услугах;</li>
          <li>инциденты кибербезопасности, такие как хакерские атаки, вирусы и вредоносные программы;</li>
          <li>
            обстоятельства непреодолимой силы, такие как тайфуны, землетрясения, наводнения, пожары, войны и действия
            государственных органов;
          </li>
          <li>причины, связанные с оборудованием, сетью, учётной записью или действиями самого пользователя;</li>
          <li>нарушение пользователем настоящего Соглашения или иных правил платформы Xiangji;</li>
          <li>иные причины, не связанные с виной самой Xiangji.</li>
        </ol>
      </section>
      <section>
        <h2>11. Управление учётными записями и нарушения</h2>
        <ol>
          <li>
            Если Xiangji обнаружит или будет иметь разумные основания полагать, что пользователь нарушил законы и
            нормативные акты, настоящее Соглашение или иные правила платформы, Xiangji вправе в зависимости от
            конкретных обстоятельств принять меры, включающие, помимо прочего, следующие:
            <ul>
              <li>предупреждения;</li>
              <li>ограничение отдельных функций;</li>
              <li>приостановку соответствующих услуг;</li>
              <li>ограничение входа в учётную запись;</li>
              <li>приостановку или прекращение действия учётных записей;</li>
              <li>удаление связанного незаконного контента;</li>
              <li>списание аномально полученных сервисных квот в соответствии с правилами;</li>
              <li>передачу сведений в соответствующие органы в соответствии с законом.</li>
            </ul>
          </li>
          <li>
            Если вследствие незаконного или несоответствующего требованиям поведения пользователя Xiangji терпит
            претензии третьих лиц, административные взыскания, судебную ответственность или иные убытки, пользователь
            несёт соответствующую ответственность в соответствии с законом.
          </li>
          <li>
            Если учётная запись пользователя приостановлена или прекращена, пользователь тем не менее несёт уже
            возникшую ответственность в соответствии с законами, нормативными актами и соответствующими соглашениями.
          </li>
        </ol>
      </section>
      <section>
        <h2>12. Аномалии транзакций и сбои системы</h2>
        <ol>
          <li>
            Если сбой системы Xiangji приводит к несоответствию между фактически приобретёнными пользователем
            преимуществами подписки и записями заказов, пользователь может предоставить соответствующие платёжные
            документы и информацию о заказе через каналы службы поддержки. После проверки и подтверждения со стороны
            Xiangji компания в зависимости от фактических обстоятельств примет разумные меры урегулирования, такие как
            пополнение преимуществ, исправление заказов или иные.
          </li>
          <li>
            Если сбой системы приводит к получению пользователем преимуществ подписки, превышающих соответствующие
            фактически уплаченной сумме, Xiangji вправе исправить или взыскать аномальные преимущества.
          </li>
          <li>
            Если будет обнаружено, что пользователь получил аномальные преимущества подписки, используя уязвимости
            системы, технические средства или иные способы, Xiangji вправе аннулировать соответствующие аномальные
            преимущества и принять дальнейшие меры в зависимости от обстоятельств.
          </li>
        </ol>
      </section>
      <section>
        <h2>13. Изменение Соглашения</h2>
        <p>
          Xiangji вправе изменять настоящее Соглашение в соответствии с законами и нормативными актами, развитием
          бизнеса и изменениями услуг.
        </p>
        <p>
          При существенных изменениях Соглашения Xiangji уведомит пользователей через объявления на веб-сайте, страницы
          продуктов, внутренние уведомления или иные разумные способы.
        </p>
        <p>
          <strong>
            Если вы не согласны с изменённым Соглашением, вы можете прекратить использование соответствующих услуг
            подписки; если вы продолжаете приобретать или использовать услуги подписки, считается, что вы приняли
            изменённое Соглашение.
          </strong>
        </p>
        <p>Обновлённое Соглашение вступает в силу с даты публикации или согласованной даты вступления в силу.</p>
      </section>
      <section>
        <h2>14. Связь с Xiangji</h2>
        <p>
          Если у вас есть вопросы о настоящем Соглашении, услугах подписки, заказах, возвратах или иных связанных
          вопросах, вы можете связаться с Xiangji следующими способами:
        </p>
        <ul>
          <li>
            Официальный веб-сайт:
            <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
              https://www.xiangjifanyi.com/
            </a>
          </li>
          <li>Онлайн-служба поддержки: онлайн-служба поддержки в продуктах Xiangji</li>
          <li>Электронная почта службы поддержки: 510807298@qq.com</li>
          <li>Наименование компании: Suzhou Xiangji Technology Service Co., Ltd.</li>
          <li>
            Адрес компании: <strong>Ke Hai Building, No. 800 Naxian Road, Pudong New Area, Shanghai</strong>
          </li>
        </ul>
        <p>Xiangji рассмотрит ваши запросы, жалобы или замечания в разумный срок после их получения.</p>
      </section>
      <section>
        <h2>15. Применимое право и разрешение споров</h2>
        <ol>
          <li>
            Заключение, вступление в силу, исполнение, толкование и разрешение споров по настоящему Соглашению
            регулируются законодательством Китайской Народной Республики.
          </li>
          <li>
            В случае возникновения любого спора из настоящего Соглашения или услуг подписки стороны должны сначала
            разрешить его путём дружественных переговоров.
          </li>
          <li>
            Если переговоры не приводят к результату, обе стороны соглашаются передать спор на рассмотрение{' '}
            <strong>
              народному суду, обладающему юрисдикцией по месту нахождения фактического хозяйствующего субъекта Xiangji
            </strong>
            , для разрешения.
          </li>
          <li>
            Если какое-либо положение настоящего Соглашения будет признано недействительным или не подлежащим
            принудительному исполнению вследствие противоречия действующим законам и нормативным актам, это не влияет на
            действительность остальных положений настоящего Соглашения.
          </li>
        </ol>
      </section>
      <section>
        <h2>16. Вступление Соглашения в силу</h2>
        <p>
          Нажатие кнопок «Согласиться и купить», «Подтвердить покупку», «Оплатить сейчас» или иных кнопок со сходным
          значением, а равно фактическая оплата платы за подписку и начало использования услуг подписки означает, что вы
          прочитали, поняли и согласились со всем содержанием настоящего Соглашения.
        </p>
        <p>
          <strong>
            Настоящее Соглашение вступает в силу с даты завершения вами покупки услуг подписки и остаётся действительным
            в течение всего периода использования вами услуг подписки.
          </strong>
        </p>
      </section>
    </>
  );
};

export default RuContent;
